export const LIST_TYPES = {
    PERSONID: "Person_id",
    CARD: "Carte",
    EMAIL: "Email",
    MOBILE: "Téléphone mobile",
    WALLET: "Wallet",
} as const;

export const TYPE_COLORS: Record<string, "primary" | "info" | "success" | "warning" | "secondary"> = {
    [LIST_TYPES.PERSONID]: "primary",
    [LIST_TYPES.CARD]: "info",
    [LIST_TYPES.EMAIL]: "success",
    [LIST_TYPES.MOBILE]: "warning",
    [LIST_TYPES.WALLET]: "secondary",
};

export const TYPE_TRANSLATION_KEYS: Record<string, string> = {
    [LIST_TYPES.PERSONID]: "Person_id",
    [LIST_TYPES.CARD]: "card",
    [LIST_TYPES.EMAIL]: "email",
    [LIST_TYPES.MOBILE]: "mobilephone",
    [LIST_TYPES.WALLET]: "wallet",
};

export const TYPE_OPTIONS = [
    { value: LIST_TYPES.PERSONID, label: "Person_id" },
    { value: LIST_TYPES.CARD, label: "card" },
    { value: LIST_TYPES.EMAIL, label: "email" },
    { value: LIST_TYPES.MOBILE, label: "mobilephone" },
    { value: LIST_TYPES.WALLET, label: "wallet" },
] as const;

export interface ImportedList {
    LIST_ID: string | number;
    LABEL: string;
    DESCRIPTION?: string;
    IMPORT_DATE?: string;
    TOTAL_ACCOUNTS?: number;
    IS_EMAIL_LIST?: "0" | "1";
    IS_CELL_PHONE_LIST?: "0" | "1";
    IS_WALLET_LIST?: "0" | "1";
    IS_IDENTIFIER_LIST?: "0" | "1";
}

export interface ListDetails {
    TOTAL_PERSON_ID?: number;
    VALID_PHONE?: number;
    VALID_POSTAL?: number;
    VALID_EMAIL?: number;
    VALID_CELLPHONE?: number;
}

export const getListType = (list: ImportedList): string => {
    if (list.IS_EMAIL_LIST === "1") return LIST_TYPES.EMAIL;
    if (list.IS_CELL_PHONE_LIST === "1") return LIST_TYPES.MOBILE;
    if (list.IS_WALLET_LIST === "1") return LIST_TYPES.WALLET;
    if (list.IS_IDENTIFIER_LIST === "1") return LIST_TYPES.CARD;
    return LIST_TYPES.PERSONID;
};

export const convertToDeleteFormat = (list: ImportedList) => {
    const isEmailList = list.IS_EMAIL_LIST === "1";
    const isCellPhoneList = list.IS_CELL_PHONE_LIST === "1";
    const isWalletList = list.IS_WALLET_LIST === "1";
    const isCardList = list.IS_IDENTIFIER_LIST === "1";
    
    // Si aucun type n'est défini explicitement, c'est une liste de type "personne"
    const isPersonIdList = !isEmailList && !isCellPhoneList && !isWalletList && !isCardList;
    
    return {
        list_id: list.LIST_ID,
        is_email_list: isEmailList ? "1" : "0",
        is_cell_phone_list: isCellPhoneList ? "1" : "0",
        is_wallet_list: isWalletList ? "1" : "0",
        is_card_list: isCardList ? "1" : "0",
        is_personid_list: isPersonIdList ? "1" : "0",
    };
};
